import React, { useState, useCallback, useRef, memo } from "react";
import { Link } from "react-router-dom";
import { searchArticle } from "api/article";
import type { Article } from "types/api";

import { Container, SearchView } from "./style";

// 搜索结果项组件
const SearchResultItem = memo(({ item }: { item: Article }) => (
  <li>
    <Link to={`/detail/${item.id}`}>
      <div dangerouslySetInnerHTML={{ __html: item.title }} />
    </Link>
  </li>
));

SearchResultItem.displayName = "SearchResultItem";

const Searchs = memo(() => {
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState<Article[]>([]);
  const [showSearchOn, setShowSearchOn] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // 防抖处理
  const handleChangeValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const search = event.target.value.trim();

      // 清除之前的定时器
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // 设置新的定时器
      timeoutRef.current = setTimeout(() => {
        setSearchValue(search);
        if (search) {
          setShowSearch(true);
          // 获取文章列表
          searchArticle(search)
            .then((response: any) => {
              const data = response?.data;
              data && setSearchResult(data);
            })
            .catch((error) => {
              console.error("搜索失败:", error);
              setSearchResult([]);
            });
        } else {
          setShowSearch(false);
        }
      }, 500);
    },
    [],
  );

  const inputOnBlur = useCallback(() => {
    setTimeout(() => {
      setShowSearchOn(false);
    }, 200);
  }, []);

  const inputOnFocus = useCallback(() => {
    setShowSearchOn(true);
  }, []);

  return (
    <Container>
      <input
        type="search"
        placeholder="Search"
        onChange={handleChangeValue}
        onBlur={inputOnBlur}
        onFocus={inputOnFocus}
      />
      {/* 搜索数据弹框 */}
      {showSearchOn && showSearch ? (
        <SearchView>
          <div className="search_header">TITLE</div>
          <ul className="search_body">
            {searchResult.length > 0 ? (
              searchResult.map((item) => (
                <SearchResultItem key={item.id} item={item} />
              ))
            ) : (
              <li>No Results found for query "{searchValue}"</li>
            )}
          </ul>
        </SearchView>
      ) : null}
    </Container>
  );
});

Searchs.displayName = "Searchs";

export default Searchs;
